import { type ComponentPublicInstance, shallowRef } from 'vue'
import type FileShareDialog from '~/components/file-share-dialog/FileShareDialog.vue'

const fileShareDialog = shallowRef<InstanceType<typeof FileShareDialog> | null>(null)

export const globalComponents = {
  register: {
    fileShareDialog: (instance: Element | ComponentPublicInstance | null): void => {
      fileShareDialog.value = instance as InstanceType<typeof FileShareDialog> | null
    },
  },
  fileShareDialog: (): InstanceType<typeof FileShareDialog> => {
    if (fileShareDialog.value === null) {
      throw new Error('FileShareDialog is not registered in App.vue')
    }

    return fileShareDialog.value
  },
}
